
export default {
  name: 'SkeletonTableLoader',
  props: {
    rows: {
      type: Number,
      default: 5
    },
    cols: {
      type: Number,
      default: 6
    },
    animation: {
      type: String,
      default: 'wave' // you can also use 'blink' or 'pulse'
    }
  },
  methods: {
    getRandomWidth(col) {
      // Gives a bit of visual variation between columns
      const widths = ['25px', '35px', '50px', '65px', '85px', '100px'];
      return widths[col % widths.length];
    }
  }
};
